// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

class People extends React.Component {
	render() {
		const { page, people } = this.props
		let markup,
			markupAdvisory,
			markupCommittee

		if ( ! people || ! Object.keys( people ).length ) {
			return null
		}

		markup = Object.keys( people ).map( key => {
			let item = people[ key ]

			if ( item.page.indexOf( page.template ) === -1  ) {
				return
			}

			return (
				<div className="-person" key={ key }>
					<div className="-image">
						<img
							src={ item.image.url }
							srcSet={ item.image.srcset }
							sizes={ `(max-width: ${siteData.mobile_max_width}) 50vw, 400px` }
							alt={ item.image.alt }
						/>
					</div>

					<div className="-text">
						<h3 className="-name">{ item.name }</h3>
						<p className="-title">{ item.people_title }</p>
					</div>
				</div>
			)
		} )

		markupAdvisory = Object.keys( people ).map( key => {
			let item = people[ key ]

			if ( item.page.indexOf( 'advisory' ) === -1  ) {
				return
			}

			return (
				<div className="-person" key={ key }>
					<div className="-image">
						<img
							src={ item.image.url }
							srcSet={ item.image.srcset }
							sizes={ `(max-width: ${siteData.mobile_max_width}) 50vw, 400px` }
							alt={ item.image.alt }
						/>
					</div>

					<div className="-text">
						<h3 className="-name">{ item.name }</h3>
						<p className="-title">{ item.board_title }</p>
					</div>
				</div>
			)
		} )

		markupCommittee = Object.keys( people ).map( key => {
			let item = people[ key ]

			if ( item.page.indexOf( 'committee' ) === -1  ) {
				return
			}

			return (
				<div className="-person" key={ key }>
					<div className="-image">
						<img
							src={ item.image.url }
							srcSet={ item.image.srcset }
							sizes={ `(max-width: ${siteData.mobile_max_width}) 50vw, 400px` }
							alt={ item.image.alt }
						/>
					</div>

					<div className="-text">
						<h3 className="-name">{ item.name }</h3>
						<p className="-title">{ item.committee_title }</p>
					</div>
				</div>
			)
		} )

		if ( 'board' == page.template ) {
			return (
				<div className="people">
					<div className="-inner">
						<h2>ATSIM Advisory</h2>

						{ markupAdvisory }

						<h2>ATSIM Committee</h2>

						{ markupCommittee }
					</div>
				</div>
			)
		}

		return (
			<div className="people">
				<div className="-inner">
					{ markup }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		people: state.site.people
	}
}

export default connect( mapStateToProps )( People )



// WEBPACK FOOTER //
// ./views/page/People.jsx